module.exports = __webpack_public_path__ + "media/images/companyPage/agility-800f6b221943264587ffa7385f66c5d8.svg";